import {
  DestroyReimbursementBudgetPayload,
  MutationDestroyReimbursementBudgetArgs,
} from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { gql } from "@apollo/client"

const DESTROY_REIMBURSEMENT_BUDGET_MUTATION = gql`
  mutation destroyReimbursementBudget($input: DestroyReimbursementBudgetInput!) {
    destroyReimbursementBudget(input: $input) {
      errors
    }
  }
`

export const useDestroyReimbursementBudgetMutation = (
  options: InjectedOptions<
    { destroyReimbursementBudget: DestroyReimbursementBudgetPayload },
    MutationDestroyReimbursementBudgetArgs
  >,
) =>
  useMutation(DESTROY_REIMBURSEMENT_BUDGET_MUTATION, {
    ...options,
  })
